import {
  LivePortraitFragment,
  SingingPortraitFragment,
} from 'api/contentful/contentful.graphql.types'
import {
  SBanner,
  SBannerContent,
  SBannerGallery,
  SButton,
  STextContainer,
} from './LifeStoriesBanner.styled'
import { NO_OF_VIDEOS } from 'components/content/lifeStories/lifeStoriesBanners/LifeStoriesBanners'
import { Text } from 'components/Typography'
import { VideoCarousel } from 'components/videoCarousel/VideoCarousel'
import { useTranslation } from 'next-i18next'
import { forwardRef, HTMLAttributes, ReactElement, ReactNode, useState } from 'react'
import { GenericFunction } from 'utils/types'

interface Props {
  uploadPlaceholder?: ReactElement | false
  onClick: GenericFunction
  carouselData?: (SingingPortraitFragment | LivePortraitFragment)[]
  title?: string
  description?: string
  buttonText?: ReactNode
  showMuteButton?: boolean
}

export const AnimatedPortraitBanner = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & Props
>(
  (
    { title, description, onClick, carouselData, uploadPlaceholder, buttonText, showMuteButton },
    ref
  ) => {
    const [index, setIndex] = useState<number>(0)
    const [isHovered, setIsHovered] = useState(false)

    const { t } = useTranslation('life_stories')

    const onVideoEnded = () => {
      if (isHovered) return
      setIndex((prev) => (prev + 1) % NO_OF_VIDEOS)
    }

    const commonAnimationBannerProps = {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
    }

    return (
      <SBanner {...commonAnimationBannerProps} ref={ref}>
        <SBannerContent>
          <STextContainer>
            <Text variant="bodyBold" color="black">
              {title}
            </Text>

            <Text>{description}</Text>
          </STextContainer>

          <SButton type="button" variant="text" size={['small', 'medium']} onClick={onClick}>
            {buttonText ?? t('life_stories.inside_page.banners.upload_button')}
          </SButton>
        </SBannerContent>

        <SBannerGallery>
          {uploadPlaceholder || (
            <VideoCarousel
              hideActionText
              hideNavigation
              items={carouselData}
              disableAudio={!showMuteButton}
              forcedIndex={index}
              onVideoEnded={onVideoEnded}
              setForcedIndex={setIndex}
            />
          )}
        </SBannerGallery>
      </SBanner>
    )
  }
)
AnimatedPortraitBanner.displayName = 'AnimatedPortraitBanner'
